<div class="otp-wrapper">

    <!-- View Toggle -->
    <div class="otp-view-toggle">
        <mat-button-toggle-group [(ngModel)]="viewType" aria-label="View Type" (change)="onViewChange(viewType)">
            <mat-button-toggle value="createLogin">
                <mat-icon class="toggle-icon">vpn_key</mat-icon>
                Generate Code
            </mat-button-toggle>
            <mat-button-toggle value="tableInstructions">
                <mat-icon class="toggle-icon">table_restaurant</mat-icon>
                Table Setup Guide
            </mat-button-toggle>
            <mat-button-toggle value="manageDevices">
                <mat-icon class="toggle-icon">list_alt</mat-icon>
                Manage Codes
            </mat-button-toggle>
        </mat-button-toggle-group>
        <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
    </div>

    <!-- Generate Code View -->
    <div *ngIf="viewType === 'createLogin'" class="otp-section">
        <ng-template *ngTemplateOutlet="createLogin"></ng-template>
    </div>

    <!-- Setup Guide View -->
    <div *ngIf="viewType === 'tableInstructions'" class="otp-section">
        <ng-template *ngTemplateOutlet="tableInstructions"></ng-template>
    </div>

    <!-- Manage Codes View -->
    <div *ngIf="viewType === 'manageDevices'" class="otp-section">
        <ng-template *ngTemplateOutlet="manageDevices"></ng-template>
    </div>

</div>

<!-- ═══════════════════════════════════════════════ -->
<!-- TEMPLATE: Generate Code                         -->
<!-- ═══════════════════════════════════════════════ -->
<ng-template #createLogin>
    <form>
        <!-- Device Role -->
        <div class="field-group">
            <label class="field-label">Device Role</label>
            <select [(ngModel)]="kioskData.role" name="role" class="role-select" (change)="onRoleChange()">
                <option value="Kiosk">Kiosk — Self-service ordering tablet</option>
                <option value="Table">Table Device — Customer orders at the table</option>
                <option value="QROrder">QR Ordering — Web-based ordering via QR code</option>
                <option value="OrdersDisplay">Kitchen Display System — Kitchen screen</option>
                <option value="ConfirmationDisplay" *ngIf="currentUser.orgSettings.featuresEnabled?.drivenThruConfirmationDisplayEnabled">Drive Through Confirmation Screen</option>
                <option value="REWARDS">Rewards — Customer loyalty terminal</option>
            </select>
        </div>

        <!-- Enable Payment (not for Rewards, Kitchen Display System, or Confirmation Display) -->
        <div class="field-group"
             *ngIf="kioskData.role !== Constants.REWARDS && kioskData.role !== Constants.ORDERS_DISPLAY && kioskData.role !== Constants.CONFIRMATION_DISPLAY">
            <mat-checkbox [(ngModel)]="kioskData.enablePayment"
                          (click)="onEnablePaymentChange($event)"
                          name="enablePayment"
                          class="payment-checkbox">
                Enable payment at this device
            </mat-checkbox>
        </div>

        <!-- Payment Method (Kiosk, QR Order, or Table with payment) -->
        <div class="field-group"
             *ngIf="(kioskData.role === Constants.KIOSK || kioskData.role === Constants.QR_ORDER || kioskData.role === Constants.TABLE) && kioskData.enablePayment">
            <label class="field-label">Payment Method</label>
            <mat-button-toggle-group class="payment-toggle-group" [value]="selectedPaymentType">
                <mat-button-toggle (change)="paymentTypeChange($event.value)" value="cloverConnector">
                    Pay on {{currentUser.orgSettings.accountType}} Device
                </mat-button-toggle>
                <mat-button-toggle (change)="paymentTypeChange($event.value)" value="qrPayment">
                    Scan To Pay (QR)
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>

        <!-- Clover Device + Nickname -->
        <div class="field-group two-col"
             *ngIf="(currentUser.orgSettings.accountType === Constants.CLOVER && (kioskData.role === Constants.KIOSK || kioskData.role === Constants.QR_ORDER)) && kioskData.enablePayment && kioskData.cloverConnectorPayment">
            <mat-form-field appearance="outline">
                <mat-label>Clover Device for Payments</mat-label>
                <mat-select [(ngModel)]="kioskData.cloverDeviceId" (selectionChange)="setDeviceSerial()" name="device">
                    <mat-option value="">None</mat-option>
                    <mat-option *ngFor="let device of cloverPaymentDevices" [value]="device.id">
                        {{device.model + ' ' + device.serial}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="kioskData.cloverConnectorPayment">
                <mat-label>Device Nickname</mat-label>
                <input matInput type="text" placeholder="e.g. Counter 1"
                       [ngModelOptions]="{standalone: true}" [(ngModel)]="kioskData.deviceAlias">
                <mat-error>Nickname is required for Clover connector payment.</mat-error>
            </mat-form-field>
        </div>

        <!-- Excluded Categories + Assign Employee (not for Rewards / KDS / Confirmation Display) -->
        <div class="field-group two-col"
             *ngIf="kioskData.role !== Constants.REWARDS && kioskData.role !== Constants.ORDERS_DISPLAY && kioskData.role !== Constants.CONFIRMATION_DISPLAY">
            <mat-form-field appearance="outline">
                <mat-label>Excluded Categories</mat-label>
                <mat-select placeholder="All categories included"
                            [(ngModel)]="kioskData.excludedCategories"
                            name="excludedCategories"
                            multiple>
                    <mat-option *ngFor="let category of cloverCategories" [value]="category.id">
                        {{ category.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Assign Employee</mat-label>
                <mat-select placeholder="No employee assigned"
                            [(ngModel)]="kioskData.assignedEmployee"
                            name="assignedEmployee">
                    <mat-option *ngFor="let employee of employees" [value]="employee.id">
                        {{ employee.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Theme (QR Order, Table, or Kiosk) -->
        <div class="field-group" *ngIf="kioskData.role === Constants.QR_ORDER || kioskData.role === Constants.TABLE || kioskData.role === Constants.KIOSK">
            <mat-form-field appearance="outline">
                <mat-label>Ordering Page Theme</mat-label>
                <mat-select [(ngModel)]="theme" (ngModelChange)="onViewThemeChange($event)" name="preferredTheme">
                    <mat-option [value]="Constants.MAINVIEW">Main</mat-option>
                    <mat-option [value]="Constants.CLASSIC_VIEW">Classic</mat-option>
                    <mat-option *ngIf="kioskData.role === Constants.TABLE || kioskData.role === Constants.KIOSK" [value]="Constants.SPLIT_VIEW">Split</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Payment Mode (Table/Kiosk + payment enabled + Split theme) -->
        <div class="field-group" *ngIf="(kioskData.role === Constants.TABLE || kioskData.role === Constants.KIOSK) && kioskData.enablePayment && theme === Constants.SPLIT_VIEW">
            <label class="field-label">Payment Mode</label>
            <mat-button-toggle-group [(ngModel)]="kioskData.paymentMode" name="paymentMode">
                <mat-button-toggle value="required">Payment Required</mat-button-toggle>
                <mat-button-toggle value="optional">Payment Optional</mat-button-toggle>
            </mat-button-toggle-group>
        </div>

        <!-- Preauthorize (when paymentMode is required) -->
        <div class="field-group" *ngIf="(kioskData.role === Constants.TABLE || kioskData.role === Constants.KIOSK) && kioskData.enablePayment && kioskData.paymentMode === 'required'">
            <mat-checkbox [(ngModel)]="kioskData.preauthorize" name="preauthorize">
                Preauthorize card before ordering
            </mat-checkbox>
        </div>

        <!-- Square Location -->
        <div class="field-group" *ngIf="currentUser.orgSettings.accountType === Constants.SQUARE">
            <mat-form-field appearance="outline">
                <mat-label>Location</mat-label>
                <mat-select formControlName="location">
                    <mat-option *ngFor="let location of locations" [value]="location.id">{{location.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Generate Button -->
        <div class="generate-area">
            <button type="button" class="generate-btn" (click)="generatePermanentCode()">
                <mat-icon>vpn_key</mat-icon>
                Generate &amp; Save Login Code
            </button>

            <!-- Code Display (after generation) -->
            <div class="code-result" *ngIf="otpGenerated">
                <div class="code-result-label">Your login code</div>
                <div class="code-result-value">{{ kioskData.otp }}</div>
                <div class="code-how-to">
                    <div class="how-to-item">
                        <mat-icon class="how-to-icon">login</mat-icon>
                        <div>
                            <strong>Manual Login:</strong> On your device, go to
                            <code class="inline-code">https://dinengo.net/login-code</code>
                            and enter the code above.
                        </div>
                    </div>
                    <div class="how-to-item">
                        <mat-icon class="how-to-icon">link</mat-icon>
                        <div>
                            <strong>Auto-Login URL</strong> (set as device startup URL):
                            <code class="inline-code break-all">https://dinengo.net/login-code?code={{kioskData.otp}}{{ kioskData.role === Constants.CONFIRMATION_DISPLAY ? '&isDevice=true' : '' }}</code>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Steps + OS links (always visible, below the button/result) -->
        <div class="steps-form-divider"></div>
        <div class="instruction-steps">
            <div class="instruction-step">
                <div class="step-num">1</div>
                <div class="step-body">
                    <strong>Generate a login code</strong>
                    <span>Select your device role above, configure any options, then click Generate.</span>
                </div>
            </div>
            <div class="instruction-step">
                <div class="step-num">2</div>
                <div class="step-body">
                    <strong>Open DineNGo on your device</strong>
                    <span>Launch the DineNGo app on your tablet, kiosk, or monitor, and enter the login code when prompted.</span>
                </div>
            </div>
            <div class="instruction-step">
                <div class="step-num">3</div>
                <div class="step-body">
                    <strong>(Optional) Lock device to single app</strong>
                    <span>For a kiosk experience, configure your device's OS to run only the DineNGo app. Guides below:</span>
                </div>
            </div>
        </div>
        <div class="os-links-row">
            <span class="os-links-label">Single-app / kiosk mode setup guides:</span>
            <button type="button" class="os-link-btn" (click)="goToLink('https://learn.microsoft.com/en-us/windows/configuration/kiosk-single-app')">
                <mat-icon class="os-link-icon">open_in_new</mat-icon> Windows
            </button>
            <button type="button" class="os-link-btn" (click)="goToLink('https://medium.com/@kanikasinha47/how-to-lock-android-tablet-or-phone-to-one-app-9aebe073b519')">
                <mat-icon class="os-link-icon">open_in_new</mat-icon> Android
            </button>
            <button type="button" class="os-link-btn" (click)="goToLink('https://www.hexnode.com/blogs/what-is-ios-kiosk-mode/')">
                <mat-icon class="os-link-icon">open_in_new</mat-icon> iOS
            </button>
        </div>
    </form>
</ng-template>

<!-- ═══════════════════════════════════════════════ -->
<!-- TEMPLATE: Setup Guide                           -->
<!-- ═══════════════════════════════════════════════ -->
<ng-template #tableInstructions>
    <div class="setup-guide">

        <div class="os-links-row">
            <span class="os-links-label">Single-app / kiosk mode setup guides:</span>
            <button type="button" class="os-link-btn" (click)="goToLink('https://learn.microsoft.com/en-us/windows/configuration/kiosk-single-app')">
                <mat-icon class="os-link-icon">open_in_new</mat-icon> Windows
            </button>
            <button type="button" class="os-link-btn" (click)="goToLink('https://medium.com/@kanikasinha47/how-to-lock-android-tablet-or-phone-to-one-app-9aebe073b519')">
                <mat-icon class="os-link-icon">open_in_new</mat-icon> Android
            </button>
            <button type="button" class="os-link-btn" (click)="goToLink('https://www.hexnode.com/blogs/what-is-ios-kiosk-mode/')">
                <mat-icon class="os-link-icon">open_in_new</mat-icon> iOS
            </button>
        </div>

        <!-- Table Auto-Login Section -->
        <div class="autologin-section">
            <h4 class="autologin-title">Table Device — Auto-Login URL</h4>
            <p class="autologin-desc">Select a table to generate an auto-login URL. Set this as the startup URL on the table's tablet so it logs in automatically on launch.</p>

            <div class="table-picker-stack">
                <mat-form-field appearance="outline" class="table-picker-field">
                    <mat-label>Select Table</mat-label>
                    <mat-select name="roleSelect" (selectionChange)="addTableToAutologin($event.value)">
                        <mat-optgroup [label]="'MAIN DINING'">
                            <mat-option *ngFor="let table of tables" [value]="table.name">{{table.name}}</mat-option>
                        </mat-optgroup>
                        <mat-optgroup *ngFor="let layout of currentUser.orgSettings.additionalLayouts | keyvalue"
                                      [label]="layout.key">
                            <mat-option *ngFor="let table of layout.value" [value]="table.name">
                                {{table.name.split(layout.key + ' -')[1]?.toLocaleLowerCase()}}
                            </mat-option>
                        </mat-optgroup>
                    </mat-select>
                </mat-form-field>
                <app-qr-generator [height]="130" [width]="130" [qrUrl]="qrUrl"
                                  [title]="('orderConfirmation.paymentQrTitle' | translate)"></app-qr-generator>
            </div>

            <div class="url-field-row">
                <label class="url-field-label">Auto-login URL</label>
                <input class="url-field-input" type="text" [value]="tableAutoLoginURL" readonly/>
            </div>
            <div class="url-divider"><span>or log in manually</span></div>
            <div class="url-field-row">
                <label class="url-field-label">Site URL</label>
                <input class="url-field-input" type="text" [value]="siteURL" readonly/>
            </div>
            <div class="url-field-row">
                <label class="url-field-label">Username</label>
                <input class="url-field-input" type="text" [value]="tableUsername" readonly/>
            </div>
            <div class="url-field-row">
                <label class="url-field-label">Password</label>
                <input class="url-field-input" type="text" [value]="kioskData.otp" readonly/>
                <span class="or-text">OR</span>
                <button type="button" class="perm-code-link" (click)="viewType = 'createLogin'">Generate Permanent Code</button>
            </div>
            <div class="otp-login-note">
                To log in using this one-time code, visit
                <strong>{{environment.subdomainUrl}}</strong>.
                You may also go to <strong>www{{environment.subdomainUrl}}/login</strong> and enter the credentials above.
            </div>
            <div class="otp-login-warning">
                Note: You may use either the one-time code above or a Permanent Code for table login.
            </div>
        </div>
    </div>
</ng-template>

<!-- ═══════════════════════════════════════════════ -->
<!-- TEMPLATE: Manage Codes                          -->
<!-- ═══════════════════════════════════════════════ -->
<ng-template #manageDevices>
    <div class="manage-codes">
        <p class="manage-empty-msg" *ngIf="permanentCodes.length === 0">
            <mat-icon>info_outline</mat-icon>
            No login codes yet. Use the <strong>Generate Code</strong> tab to create one.
        </p>
        <table class="codes-table" *ngIf="permanentCodes.length > 0">
            <thead>
            <tr>
                <th>Code</th>
                <th>Device Role</th>
                <th>Expiry</th>
                <th>QR</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let code of permanentCodes">
                <td><span class="code-chip">{{ code.code }}</span></td>
                <td><span class="role-chip">{{ roleDisplayName(code.role) }}</span></td>
                <td>
                    <span class="expiry-permanent" *ngIf="!code.expireAt">Permanent</span>
                    <span class="expiry-date" *ngIf="code.expireAt">{{ code.expireAt }}</span>
                </td>
                <td>
                    <button class="icon-btn" (click)="openLoginQr(code)" title="View auto-login QR">
                        <mat-icon color="primary">qr_code</mat-icon>
                    </button>
                </td>
                <td>
                    <button class="icon-btn" (click)="deleteCode(code.code)" title="Delete code">
                        <mat-icon color="warn">delete</mat-icon>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</ng-template>
